import { useEffect, useContext } from 'react'
import { SocketContext } from 'supportAssistant/contexts/SocketContext'
import type { EventType } from 'api/supportAssistant'

// TODO: Replace it with contract event bodies
export type EventBodies = unknown

export default function useSocketEvent<T extends EventBodies>(eventType?: EventType, callback: (event: T) => void = () => {}) {
  const { socket } = useContext(SocketContext)

  const emitSocketEvent = <T extends EventBodies>(payload: T) => {
    socket?.emit(eventType as EventType, payload)
  }

  useEffect(() => {
    socket?.on(eventType || '', callback)

    return () => {
      socket?.off(eventType)
    }
  }, [socket, eventType, callback])

  return emitSocketEvent
}
